// Whose numbers the Activity page opens on.
//
// A strategist opens on their own row: "how is my month going" is their question, and the team
// total answers somebody else's. Anyone without a row (leadership, admin, a viewer) opens on the
// whole team. Picking a scope, including "All strategists", always wins over this default.
//
// Pure, and imported by `node --test`.

import type { StrategistRow } from '../api/types';

export function defaultStrategist(rows: StrategistRow[], viewerEmail: string | null | undefined): string | null {
  if (!viewerEmail) return null;
  const wanted = viewerEmail.toLowerCase();
  const own = rows.find(row => (row.sdr_owner_email ?? '').toLowerCase() === wanted);
  return own?.sdr_owner_email ?? null;
}
